import { createSelector } from '@ngrx/store';

import { selectDashboardState } from '../dashboard.selectors';

const selectSubscriptionAlertsState = createSelector(
  selectDashboardState,
  (dashhboardState) => dashhboardState.subscriptionAlerts
);

export const selectSubscriptionAlerts = createSelector(
  selectSubscriptionAlertsState,
  (subscriptionAlertsState) => subscriptionAlertsState.alerts
);

export const selectSubscriptionAlertsMaxId = createSelector(
  selectSubscriptionAlerts,
  (subscriptionAlerts) => {
    return subscriptionAlerts
      .map((alert) => alert.id)
      .reduce((maxId, currentValue) => {
        return currentValue > maxId ? currentValue : maxId;
      }, 0);
  }
);
